import {
    SET_IS_ERROR_LEAD_DISPOSITION,
    SET_IS_LOADING_LEAD_DISPOSITION,
    SET_IS_SUCCESS_LEAD_DISPOSITION,
} from '../constants/get_lead_disposition.constants';

export const setIsLoadingLeadDisposition = (isLoading) => ({
    type: SET_IS_LOADING_LEAD_DISPOSITION,
    isLoading,
});

export const setIsSuccessLeadDisposition = (payload) => ({
    type: SET_IS_SUCCESS_LEAD_DISPOSITION,
    payload,
});

export const setIsErrorLeadDisposition = (error) => ({
    type: SET_IS_ERROR_LEAD_DISPOSITION,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_lead_disposition.actions.js